export default __webpack_public_path__ + "static/char-s-47-en-871c81f484ee6e9bc4b0ca88b2a2974e.png";